import { render, staticRenderFns } from "./CardAula.vue?vue&type=template&id=11a38d2c"
import script from "./CardAula.vue?vue&type=script&lang=js"
export * from "./CardAula.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports